import { render, staticRenderFns } from "./StatusCirurgiaModal.vue?vue&type=template&id=7d04b9f3&scoped=true"
import script from "./StatusCirurgiaModal.vue?vue&type=script&lang=js"
export * from "./StatusCirurgiaModal.vue?vue&type=script&lang=js"
import style0 from "./StatusCirurgiaModal.vue?vue&type=style&index=0&id=7d04b9f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d04b9f3",
  null
  
)

export default component.exports